import * as React from "react";
import { themed } from "@adc/parallax-icons";
const SvgMenu = themed((props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0v8h8V0zm6 6H2V2h4zm-6 4v8h8v-8zm6 6H2v-4h4zm4-16v8h8V0zm6 6h-4V2h4zm-6 4v8h8v-8zm6 6h-4v-4h4z" })));
export default SvgMenu;
